// Instance axios pointant vers DartsHub backend — pour les licences (cross-service)
import axios from 'axios';
import { useAuthStore } from '@/stores/useAuthStore';
import { dartshub_url } from '@/config/config';

const dartsHubApi = axios.create({ baseURL: dartshub_url, timeout: 30000 });

dartsHubApi.interceptors.request.use((config) => {
  const { token } = useAuthStore();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

dartsHubApi.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401) useAuthStore().logout();
    return Promise.reject(error);
  }
);

export default dartsHubApi;
